import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
} from "react-bootstrap";
import Datetime from "react-datetime";
import Card from "components/Card/Card.jsx";
import Select from "react-select";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";

import NotificationSystem from "react-notification-system";

import axios from "axios";
import {
  getuserbyid,
  updateSubscription,
  getCountry,
  updateuser,
  searchSpeciality,
  GetSchedule,
  getInsuaranceCompanyList,
  getOrganizationDataWithoutPagination,
  getBrachDetailsCountryCodeWise,
  getCity,
} from "Listfunction";
import { style } from "variables/Variables";

class EditUserPo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      cfpassword: "",
      emailError: null,
      passwordError: null,
      cfpasswordError: null,
      mobilenoError: null,
      nameError: null,
      useraccess: "",
      ccode: "+94",
      processing: true,
      name: "",
      mobileno: "",
      role: "0",
      roleError: null,
      proofurl: [],
      profile: "",
      errormessage: "",
      profile_data: "",
      errormessages: [],
      gender: "",
      profile: "",
      addressline1: "",
      addressline1Error: null,
      addressline2: "",
      city: "0",
      cityError: null,
      postalcode: "",
      postalcodeError: null,
      country: "0",
      countryError: null,
      state: "",
      oldprofile: "",
      selectedFile: [],
      country_detail: [],
      city_info: [],
      is_sales_rep: 0,
      showOption: false,
      company_name: "",
      insuarance_ref: false,
      doctor_speciality: "",
      doctor_specialityError: null,
      qualification: "",
      qualificationError: null,
      registration_id: "",
      registration_idError: null,
      signature_url: "",
      signature_urlError: null,
      oldSignatutefile: "",
      signature: "",
      signature_data: "",
      doctorspecialityItems: [],
      specialityList: [],
      insuaranceCompanyList: [],
      consultation_fee: "",
      consultation_rate: "",
      medication_rate: "",
      lab_rate: "",
      doctor_languageError: "",
      doctor_language: [],
      quality: "",
      doctor_preference: "",
      is_show_in_app: "No",
      is_show_allow: false,
      doctor_prefix: "",
      // doc_prefix_err: "",
      insuarance_ref_err: "",
      country_code: "",
      branchList: [],
      district: "",
      chargeType: null,
      chargeTypeOptions: [
        { value: "paid", label: "Paid" },
        { value: "free", label: "Free" },
      ],
      store: null,
      storeError: null,
      storeOption: [],
      is_Home_Care_Enabled: false,
      insuarance_company: "",
      department: "",
      sort: null,
      leadTime: "",
      leadTimeBuffer: "",
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleFileChangeMultiple = this.handleFileChangeMultiple.bind(this);
    this.handleSignatureFileChange = this.handleSignatureFileChange.bind(this);
  }
  isSalesRepresntative = (e) => {
    var checked = e.target.checked;
    this.setState({ is_sales_rep: checked });
  };
  isHomeCare = (e) => {
    var checked = e.target.checked;
    this.setState({ is_Home_Care_Enabled: checked });
  };
  async handleFileChangeMultiple(event) {
    let data = [];
    data.push(event.target.files);
    this.setState({ selectedFile: data });
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>User</b> - Updated Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
    setTimeout(() => {
      this.props.history.push("/admin/addPoNew");
    }, 2000);
  }

  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  docDescChange(event) {
    var value = event.target.value;
    this.setState({ doc_desc_err: "", doc_desc: value });
  }

  docExpChange(event) {
    var value = event.target.value;
    var re = /^[0-9]*$/;
    if (re.test(value) == true && value <= 20) {
      this.setState({ doc_exp_err: "", doc_exp: value });
    }
  }

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({
      useraccess: token.role,
    });
    var id = JSON.parse(localStorage.getItem("CustomerID"));

    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );

    var countryCode = "";
    await getuserbyid(id, obj).then((res) => {
      console.log(res);
      var data = res.data;
      var mstr = data.mobile;
      var mobile = mstr.slice(3);
      var ccode = mstr.slice(0, 3);
      var prescriptiondetails = [];
      countryCode = data.country_code;

      // if (data.proof_urls != null && data.proof_urls.length !== 0) {
      //   const splic = data.proof_urls.split(",");
      //   // console.log(splic,'splic',hc)

      //   splic.map((fd) => {
      //     console.log(fd, "fd");
      //     prescriptiondetails.push({ proof_url: fd });
      //   });
      // } else {
      //   prescriptiondetails = [];
      // }

      if ((data.proof_urls = null && data.proof_urls.length !== 0)) {
        const splic = data.proof_urls.split(",");

        splic.map((fd) => {
          prescriptiondetails.push({ proof_url: fd });
        });
      } else {
        prescriptiondetails = [];
      }

      this.setState({ proofurl: prescriptiondetails });
      this.setState({
        name: data.name,
        email: data.email,
        mobileno: mobile,
        ccode: ccode,
        role: data.role,
        addressline1: data.address_line1,
        addressline2: data.address_line2,
        city: data.city,
        postalcode: data.postal_code,
        country: data.country_id,
        state: data.state,
        oldprofile: data.profile_picture_url,
        is_sales_rep: data.is_sales_rep,
        gender: data.gender,
        insuarance_company: Number(data.company_tags),
        district: data.district,
        store: !!data.store_details
          ? { value: data.store_details.id, label: data.store_details.name }
          : null,
        is_Home_Care_Enabled: data.is_homecare_enabled,
        department: data.department,
        sort: data.sort,
        leadTime: data.lead_time_days,
        leadTimeBuffer: data.lead_time_days_buffer,
        // qualification: data.doctor_detail.qualification,
        // registration_id: data.doctor_detail.registration_id,
        // oldSignatutefile: data.doctor_detail.signature_url,
      });

      if (data.doctor_type == 1) {
        if (data.doctor_detail != null) {
          this.setState({
            qualification: data.doctor_detail.qualification,
            registration_id: data.doctor_detail.registration_id,
            oldSignatutefile: data.doctor_detail.signature_url,
          });
        } else {
          this.setState({
            qualification: "",
            registration_id: "",
            oldSignatutefile: null,
          });
        }
      } else {
        this.setState({
          qualification: "",
          registration_id: "",
          oldSignatutefile: null,
        });
      }

      if (data.role == 9) {
        var doc_selectedop = [];
        if (data.doctor_detail.language) {
          var dc_lan = data.doctor_detail.language.split(",");
          dc_lan.map((lan, idx) => {
            var details = { value: lan, label: lan };
            doc_selectedop.push(details);
          });
        }

        var isShowApp = "No";
        if (data.doctor_detail.is_show_in_app == 1) {
          isShowApp = "Yes";
        }
        const getSelectedChargeType = this.state.chargeTypeOptions.find(
          (item) => item.value === data.doctor_detail.charge_type,
        );
        this.setState({
          showOption: true,
          qualification: data.doctor_detail.qualification,
          registration_id: data.doctor_detail.registration_id,
          oldSignatutefile: data.doctor_detail.signature_url,
          consultation_fee: data.doctor_detail.consultation_fee,
          doctor_language: doc_selectedop ? doc_selectedop : [],
          quality: data.doctor_detail.quality,
          is_show_in_app: isShowApp,
          doctor_prefix: data.doctor_detail.doctor_prefix,
          doctor_preference: data.doctor_preference,
          chargeType: getSelectedChargeType,
        });
      } else if (data.role == 15) {
        this.setState({
          insuarance_ref: true,
          company_name: data.company_tags,
        });
      } else {
        this.setState({
          showOption: false,
          qualification: "",
          registration_id: "",
          oldSignatutefile: "",
        });
      }
      var specialityvalue = data.doctor_speciality;
      var activespeciality = [];
      var pcItems = [];
      var setvaluespe = "";
      searchSpeciality(obj).then((response) => {
        const mdata = response.data;
        for (let i = 0; i < mdata.length; i++) {
          if (mdata[i].is_active == 1) {
            activespeciality.push(mdata[i]);
          }
        }
        activespeciality.map((x, i) => {
          pcItems.push({ value: x.id, label: x.title });
        });
        this.setState({
          doctorspecialityItems: pcItems,
          specialityList: activespeciality,
        });

        for (let i = 0; i < pcItems.length; i++) {
          for (let z = 0; z < specialityvalue.length; z++) {
            if (pcItems[i].value == specialityvalue[0].speciality_id) {
              setvaluespe = pcItems[i];
            }
          }
        }
        this.setState({
          doctor_speciality: setvaluespe,
        });
      });
    });
    let countryList = [];
    await getCountry(obj).then((cdata) => {
      const countrydata = cdata.data;
      countryList = cdata.data;
      this.setState({
        country_detail: countrydata,
      });
    });
    // const findCountryCode = countryList.find((data) => data.id === Number(countryId))
    // const countryCode = findCountryCode.country_code

    await getBrachDetailsCountryCodeWise(countryCode, obj).then((res) => {
      let branchList = [];
      if (res.data.length > 0) {
        branchList = res.data.map((branch) => {
          return {
            value: branch.id,
            label: branch.name,
          };
        });
      }
      this.setState({ branchList: branchList });
    });

    this.handleCompanyNameOptionsOnChange();

    getInsuaranceCompanyList(obj).then((cdata) => {
      const companyData = cdata.data;
      this.setState({
        insuaranceCompanyList: companyData,
      });
    });

    GetSchedule(obj, id).then((response) => {
      var sch_data = response.data.doctor_schedule;

      var isdocTime = false;
      if (sch_data.length > 0) {
        isdocTime = true;
      }

      this.setState({
        is_show_allow: isdocTime,
      });
    });
  }
  handleLeadTimechnage(event) {
    const leadTimeValue =
      event && event.target ? event.target.value : event ? event.value : "";
    this.setState({ leadTime: leadTimeValue });
  }
  handleLeadTimeBufferChange(event) {
    const leadTimeBuffer =
      event && event.target ? event.target.value : event ? event.value : "";
    this.setState({ leadTimeBuffer: leadTimeBuffer });
  }
  handleEmailChange(event) {
    this.setState({
      email: event.target.value,
    });
    var re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    re.test(event.target.value) === false
      ? this.setState({
          emailError: (
            <small className="text-danger">
              Email is required and format should be <i>abc@def.com</i>.
            </small>
          ),
        })
      : this.setState({ emailError: null });
  }

  hadlemobilenochange(event) {
    this.setState({
      mobileno: event.target.value,
    });
    var digitRex = /^\d+$/;
    digitRex.test(event.target.value) === false
      ? this.setState({
          mobilenoError: (
            <small className="text-danger">mobileno has to be a number.</small>
          ),
        })
      : this.setState({ type_numberError: null });
  }

  handlenamechnage(event) {
    this.setState({ name: event.target.value });
    event.target.value === ""
      ? this.setState({
          nameError: <small className="text-danger">name is required.</small>,
        })
      : this.setState({ type_textError: null });
  }

  handlequalificationchnage(event) {
    this.setState({ qualification: event.target.value });
    event.target.value === ""
      ? this.setState({
          qualificationError: (
            <small className="text-danger">qualification is required.</small>
          ),
        })
      : this.setState({ type_textError: null });
  }

  handleregistration_idchnage(event) {
    this.setState({ registration_id: event.target.value });
    event.target.value === ""
      ? this.setState({
          registration_idError: (
            <small className="text-danger">registration_id is required.</small>
          ),
        })
      : this.setState({ type_textError: null });
  }

  handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const findCountryCode = this.state.country_detail.find(
      (data) => data.id === Number(value),
    );
    const countryCode = findCountryCode.country_code;

    if (value != "0") {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      getBrachDetailsCountryCodeWise(countryCode, obj).then((res) => {
        this.setState({ branchList: res.data });
      });

      var country_id = value;
      getCity(obj, country_id).then((res) => {
        this.setState({ city_info: res.data });
      });
    } else if (value == "0") {
      this.setState({ city_info: [], branchList: [] });
    }
    this.setState({
      [name]: value,
    });
  };

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    if (name == "country") {
      const country_code = this.state.country_detail.find(
        (item) => item.id == value,
      ).country_code;
      this.setState({ country_code: country_code });
    }

    if (name == "doctor_prefix") {
      this.setState({
        // doc_prefix_err: "",
        [name]: value,
      });
    } else if (name == "insuarance_company") {
      this.setState({
        insuarance_company_err: "",
        [name]: value,
      });
      console.log(this.companyName);
    } else {
      this.setState({
        [name]: value,
      });
    }
  };

  onCunsultFeeChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const re = /^[0-9]*$/;

    if (re.test(value) == true) {
      this.setState({
        [name]: value,
      });
    }
  };
  onCunsultRateChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const re = /^[0-9]*$/;

    if (re.test(value) == true) {
      this.setState({
        [name]: value,
      });
    }
  };
  onMedicationRateChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const re = /^[0-9]*$/;

    if (re.test(value) == true) {
      this.setState({
        [name]: value,
      });
    }
  };
  onLabRateChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const re = /^[0-9]*$/;

    if (re.test(value) == true) {
      this.setState({
        [name]: value,
      });
    }
  };

  async onSubmit() {
    this.setState({ errormessages: [] });
    let error = false;
    if (this.state.name.length == 0) {
      error = true;
      this.setState({
        nameError: <small className="text-danger">Name is required.</small>,
      });
    } else {
      this.setState({ nameError: null });
    }
    if (this.state.mobileno.length < 9 || this.state.mobileno.length > 11) {
      error = true;
      this.setState({
        mobilenoError: (
          <small className="text-danger">
            Please enter mobile nunber from 9 to 11 digit.
          </small>
        ),
      });
    } else {
      this.setState({ mobilenoError: null });
    }
    if (this.state.email.length == 0) {
      error = true;
      this.setState({
        emailError: <small className="text-danger">Email is required.</small>,
      });
    } else {
      this.setState({ emailError: null });
    }
    if (
      this.state.role == "17" ||
      this.state.role == "18" ||
      this.state.role == "5" ||
      this.state.role == "7" ||
      this.state.role == "13" ||
      this.state.role == "6" ||
      this.state.role == "11" ||
      this.state.role == "2" ||
      this.state.role == "3"
    ) {
      if (this.state.store === null) {
        error = true;
        this.setState({
          storeError: <small className="text-danger">store is required.</small>,
        });
      } else {
        this.setState({ storeError: null });
      }
    }

    if (this.state.role == 0) {
      error = true;
      this.setState({
        roleError: <small className="text-danger">Role is required.</small>,
      });
    } else {
      this.setState({ roleError: null });
    }

    if (this.state.role == 9) {
      if (
        this.state.doctor_speciality == "" ||
        this.state.doctor_speciality == null
      ) {
        error = true;
        this.setState({
          doctor_specialityError: (
            <small className="text-danger">
              Doctor Speciality is required.
            </small>
          ),
        });
      } else {
        this.setState({ doctor_specialityError: null });
      }
    } else {
      this.setState({ doctor_speciality: [] });
    }

    // if (this.state.role == 9) {
    //   if (this.state.doctor_prefix == "") {
    //     error = true;
    //     this.setState({
    //       doc_prefix_err: (
    //         <small className="text-danger">Please select doctor prefix</small>
    //       ),
    //     });
    //   } else {
    //     this.setState({ doc_prefix_err: null });
    //   }
    // }

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var id = JSON.parse(localStorage.getItem("CustomerID"));
      var mobile = this.state.ccode + this.state.mobileno;

      if (this.state.profile.length != 0) {
        this.setState({ processing: true });

        const fdata = new FormData();
        fdata.append("profile_pic", this.state.profile);

        let url =
          process.env.REACT_APP_NOT_SECRET_CODE + "/users/upload/profilepic";
        await axios
          .post(url, fdata, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            this.setState({ profile_data: res.data.data.profile_picture_url });
          });
      } else {
        this.setState({ profile_data: this.state.oldprofile });
      }

      if (this.state.signature.length != 0) {
        this.setState({ processing: true });

        const fdata = new FormData();
        fdata.append("signature_file", this.state.signature);
        let url =
          process.env.REACT_APP_NOT_SECRET_CODE + "/users/upload/signature";
        await axios
          .post(url, fdata, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            this.setState({ signature_data: res.data.data.signature_file_url });
          });
      } else {
        this.setState({ signature_data: this.state.oldSignatutefile });
      }

      var priscription_data = "";
      if (this.state.selectedFile.length != 0) {
        this.setState({ processing: true });

        const fdata = new FormData();

        this.state.selectedFile.map((file) => {
          for (var i = 0; i < file.length; i++) {
            fdata.append("proof_files[]", file[i]);
          }
        });

        let url = process.env.REACT_APP_NOT_SECRET_CODE + "/users/upload/proof";
        await axios
          .post(url, fdata, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            priscription_data = res.data.data.proof_url;

            // priscription_array_data.push(priscription_data);
          });
      }

      var doc_speciality = [this.state.doctor_speciality.value];

      if (this.state.doctor_language.length > 0) {
        var doc_languages = [];
        this.state.doctor_language.map((lan, idx) => {
          doc_languages.push(lan.value);
        });
        doc_languages = doc_languages.join(",");
      }

      var isShowApp = "";
      if (this.state.role == 9) {
        if (this.state.is_show_in_app == "Yes") {
          isShowApp = 1;
        } else if (this.state.is_show_in_app == "No") {
          isShowApp = 0;
        }
      }

      var doctorPrefix = "";
      if (this.state.role == 9) {
        doctorPrefix = this.state.doctor_prefix;
      }

      this.setState({ processing: false }, () => {
        updateuser(
          this.state.name,
          mobile,
          this.state.email,
          this.state.role,
          doc_speciality,
          id,
          obj,
          this.state.profile_data,
          priscription_data,
          this.state.addressline1,
          this.state.addressline2,
          this.state.city,
          this.state.postalcode,
          this.state.state,
          this.state.country,
          this.state.is_sales_rep,
          this.state.gender,
          this.state.qualification,
          this.state.registration_id,
          this.state.signature_data,
          this.state.consultation_fee,
          this.state.consultation_rate,
          this.state.lab_rate,
          this.state.medication_rate,
          doc_languages,
          this.state.quality,
          isShowApp,
          doctorPrefix,
          this.state.doctor_preference,
          this.state.insuarance_company,
          this.state.district,
          this.state.country_code,
          !!this.state.chargeType ? this.state.chargeType.value : null,
          this.state.store ? this.state.store.value : null,
          this.state.is_Home_Care_Enabled,
          this.state.department,
          this.state.sort,
          this.state.leadTime,
          this.state.leadTimeBuffer,
        )
          .then((res) => {
            if (res.data.success === false) {
              this.setState({ processing: true });

              if (res.data.data.length != 0) {
                var ermessage = [];
                for (var key of Object.keys(res.data.data)) {
                  var data = res.data.data[key];
                  ermessage.push(data);
                }
                this.setState({ errormessages: ermessage });
              } else {
                this.handleClick("bl");
              }
            } else if (res.data.success === true) {
              this.handleSuccess("bl");
            }
          })
          .catch((error) => {
            console.log(error, "== error");
            this.handleNetworkError("bl");
          });
      });
    }
  }
  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleFileChange(event) {
    this.setState({ profile: event.target.files[0] });
  }
  handleSignatureFileChange(event) {
    this.setState({ signature: event.target.files[0] });
  }

  upload() {
    document.getElementById("selectImage").click();
  }
  upload2() {
    document.getElementById("selectImage2").click();
  }

  uploadSignature() {
    document.getElementById("selectSignature").click();
  }

  onSpecialityChange(value) {
    this.setState({ doctor_speciality: value });
    if (value == "" || value == null) {
      this.setState({
        doctor_specialityError: (
          <small className="text-danger">Doctor Speciality is required.</small>
        ),
      });
    } else {
      var speList = this.state.specialityList;
      for (let i = 0; i < speList.length; i++) {
        if (speList[i].id == value.value) {
          this.setState({
            doctor_specialityError: null,
            consultation_fee: speList[i].consultation_fee,
          });
        }
      }
    }
  }

  handleCompanyNameOptionsOnChange() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    getInsuaranceCompanyList(obj).then((cdata) => {
      const companyData = cdata.data;
      this.setState({
        insuaranceCompanyList: companyData,
      });
    });

    getOrganizationDataWithoutPagination(obj).then((cdata) => {
      const companyData = cdata.data;
      this.setState({
        companyList: companyData,
      });
    });
  }

  onChargeTypeChange = (value) => {
    this.setState({ charge_type: value });
  };
  handleSelectChange = (selectedOption) => {
    this.setState({
      insuarance_company: selectedOption ? selectedOption.value : "",
      insuarance_company_err: "",
    });
  };

  render() {
    const leadTimeOptions = Array.from({ length: 31 }, (_, index) => ({
      value: index + 1,
      label: `${index + 1} Days`,
    }));
    const leadTimeBufferOptions = Array.from({ length: 10 }, (_, index) => ({
      value: index + 1,
      label: `${index + 1} Days`,
    }));
    var c = 1;
    var p = 1;
    var b = 1;
    const errormessages = this.state.errormessages;
    const companyTagData = this.state.insuarance_ref
      ? this.state.insuaranceCompanyList
      : this.state.companyList;
    const insuranceOptions = companyTagData
      ? companyTagData.map((item) => ({
          value: Number(item.id),
          label: item.company_name,
        }))
      : [];
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={6}>
              <Card
                content={
                  <form>
                    <Row>
                      <Col md={12}>
                        <div className="order_source_data">
                          <FormGroup
                            className=""
                            style={{ display: "flex", gap: "10px" }}
                          >
                            <Checkbox
                              number="49"
                              checked={this.state.is_sales_rep}
                              onChange={(e) => this.isSalesRepresntative(e)}
                              label="Is Sales Rep ?"
                            ></Checkbox>
                            {this.state.role == "6" && (
                              <span style={{ marginTop: "0px" }}>
                                <Checkbox
                                  number="50"
                                  checked={this.state.is_Home_Care_Enabled}
                                  onChange={(e) => this.isHomeCare(e)}
                                  label="Is Home Care ?"
                                ></Checkbox>
                              </span>
                            )}
                          </FormGroup>
                        </div>

                        <FormGroup>
                          <ControlLabel>Role </ControlLabel>
                          <select
                            name="role"
                            value={this.state.role}
                            onChange={(event) => {
                              if (event.target.value == 9) {
                                this.setState({ showOption: true });
                                this.setState({ insuarance_ref: false });
                              } else if (event.target.value == 15) {
                                this.setState({ insuarance_ref: true });
                                this.setState({ company_name: "" });
                                this.setState({ insuarance_company: "" });
                                this.setState({ showOption: false });
                              } else {
                                this.setState({ doctor_speciality: "" });
                                this.setState({ company_name: "" });
                                this.setState({ showOption: false });
                                this.setState({ insuarance_company: "" });
                                this.setState({ insuarance_ref: false });
                              }

                              this.setState({ role: event.target.value });
                              event.target.value === "0"
                                ? this.setState({
                                    roleError: (
                                      <small className="text-danger">
                                        Role is required.
                                      </small>
                                    ),
                                  })
                                : this.setState({ roleError: null });
                            }}
                            className="form-control"
                          >
                            {this.state.useraccess == 1 && (
                              <React.Fragment>
                                <option value="0">Select Role</option>
                                <option value="1">Super Admin</option>
                                <option value="2">Admin</option>
                                <option value="3">User</option>
                                <option value="4">Third Party</option>
                                <option value="5">Rider</option>
                                <option value="6">Lab Partner</option>
                                <option value="7">Lab Rider</option>
                                <option value="8">Supplier</option>
                                <option value="9">Doctor</option>
                                <option value="10">Courier Partner</option>
                                <option value="11">Pharmacist</option>
                                <option value="12">Partner</option>
                                <option value="13">Procurement</option>
                                <option value="14">Insurance</option>
                                <option value="15">Insurance Ref</option>
                                <option value="16">Reviewer</option>
                                <option value="17">Store Manager</option>
                                <option value="18">Store Pharmacist</option>
                              </React.Fragment>
                            )}
                            {this.state.useraccess == 2 && (
                              <React.Fragment>
                                <option value="0">Select Role</option>
                                <option value="3">User</option>
                                <option value="5">Rider</option>
                                <option value="6">Lab Partner</option>
                                <option value="7">Lab Rider</option>
                                <option value="8">Supplier</option>
                                <option value="9">Doctor</option>
                                <option value="10">Courier Partner</option>
                                <option value="11">Pharmacist</option>
                                <option value="12">Partner</option>
                                <option value="13">Procurement</option>
                                <option value="14">Insurance</option>
                                <option value="15">Insurance Ref</option>
                                <option value="16">Reviewer</option>
                                <option value="17">Store Manager</option>
                                <option value="18">Store Pharmacist</option>
                              </React.Fragment>
                            )}
                            {this.state.useraccess == 13 && (
                              <React.Fragment>
                                <option value="0">Select Role</option>
                                <option value="8">Supplier</option>
                              </React.Fragment>
                            )}
                          </select>
                          {this.state.roleError}
                        </FormGroup>

                        {this.state.showOption == true && (
                          <FormGroup>
                            <ControlLabel>Doctor Prefix</ControlLabel>
                            <select
                              onChange={this.onChange}
                              name="doctor_prefix"
                              value={this.state.doctor_prefix}
                              className="form-control"
                              placeholder="Doctor Prefix"
                            >
                              <option value="">Select Doctor Prefix</option>
                              <option value="Dr.">Dr.</option>
                              <option value="Mrs.">Mrs.</option>
                              <option value="Mr.">Mr.</option>
                              <option value="Prof.">Prof.</option>
                            </select>
                            {/* {this.state.doc_prefix_err} */}
                          </FormGroup>
                        )}
                        {(this.state.insuarance_ref == true ||
                          this.state.role == "16") && (
                          <>
                            <FormGroup>
                              <ControlLabel>Company</ControlLabel>
                              <Select
                                options={insuranceOptions}
                                placeholder="Select Company"
                                value={
                                  insuranceOptions.find(
                                    (opt) =>
                                      opt.value ===
                                      this.state.insuarance_company,
                                  ) || null
                                }
                                onChange={this.handleSelectChange}
                              />

                              {this.state.insuarance_ref_err}
                            </FormGroup>
                            <FormGroup>
                              <ControlLabel>Department</ControlLabel>
                              <select
                                value={this.state.department}
                                className="form-control"
                                onChange={(event) => {
                                  this.setState({
                                    department: event.target.value,
                                  });
                                }}
                              >
                                <option value="">Select Deparment</option>
                                <option value="hr">HR</option>
                                <option value="accountant">Accountant</option>
                              </select>
                            </FormGroup>
                          </>
                        )}

                        <FormGroup>
                          <ControlLabel>Name</ControlLabel>
                          <FormControl
                            type="text"
                            onChange={(event) => this.handlenamechnage(event)}
                            required
                            name="name"
                            value={this.state.name || ""}
                            placeholder="Your  Name"
                          />
                          {this.state.nameError}
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Email</ControlLabel>
                          <FormControl
                            type="email"
                            onChange={(event) => this.handleEmailChange(event)}
                            value={this.state.email || ""}
                            placeholder="Your email Name"
                            autoComplete="off"
                          />
                          {this.state.emailError}
                        </FormGroup>
                        {this.state.role == 8 && (
                          <>
                            <FormGroup>
                              <ControlLabel>Delivery Lead Time</ControlLabel>
                              <Select
                                name="leadTime"
                                options={leadTimeOptions}
                                value={
                                  leadTimeOptions.find(
                                    (option) =>
                                      String(option.value) ===
                                      String(this.state.leadTime),
                                  ) || null
                                }
                                onChange={(option) =>
                                  this.handleLeadTimechnage(option)
                                }
                                placeholder="Select Delivery Lead Time"
                                isClearable
                              />
                            </FormGroup>
                            <FormGroup>
                              <ControlLabel>Buffer Time</ControlLabel>
                              <Select
                                name="leadTimeBuffer"
                                options={leadTimeBufferOptions}
                                value={
                                  leadTimeBufferOptions.find(
                                    (option) =>
                                      String(option.value) ===
                                      String(this.state.leadTimeBuffer),
                                  ) || null
                                }
                                onChange={(option) =>
                                  this.handleLeadTimeBufferChange(option)
                                }
                                placeholder="Select Buffer Time"
                                isClearable
                              />
                            </FormGroup>
                          </>
                        )}
                        {this.state.role == 6 && (
                          <FormGroup>
                            <ControlLabel>Sort Order</ControlLabel>
                            <FormControl
                              type="number"
                              value={this.state.sort || null}
                              onChange={(event) => {
                                this.setState({ sort: event.target.value });
                              }}
                              placeholder="Enter Sort Order"
                              onWheel={(e) => e.target.blur()}
                            />
                          </FormGroup>
                        )}
                        <FormGroup>
                          <ControlLabel>Mobile No</ControlLabel>
                          <Col md={12}>
                            <Col
                              md={2}
                              className="no-padding"
                              style={{ marginTop: "4px" }}
                            >
                              <select
                                onChange={this.onChange}
                                name="ccode"
                                value={this.state.ccode}
                                className="form-control"
                              >
                                <option value="+94">+94</option>
                                <option value="+91">+91</option>
                              </select>
                            </Col>
                            <Col md={10}>
                              <FormControl
                                type="number"
                                required
                                name="mobileno"
                                onWheel={(e) => e.target.blur()}
                                onChange={(event) => {
                                  this.setState({
                                    mobileno: event.target.value,
                                  });
                                  event.target.value.length < 9 ||
                                  event.target.value.length > 11
                                    ? this.setState({
                                        mobilenoError: (
                                          <small className="text-danger">
                                            Please enter mobile nunber from 9 to
                                            11 digit.
                                          </small>
                                        ),
                                      })
                                    : this.setState({ mobilenoError: null });
                                }}
                                value={this.state.mobileno || ""}
                                placeholder="Your Mobile Number"
                                style={{ width: "105%" }}
                              />
                            </Col>
                            {this.state.mobilenoError}
                          </Col>
                        </FormGroup>

                        {Number(this.state.role) !== 8 && (
                          <>
                            <FormGroup>
                              <ControlLabel style={{ marginTop: "5px" }}>
                                Gender
                              </ControlLabel>

                              <div className="order_source_data">
                                <Radio
                                  // style={{'display':'inline-block'}}
                                  number="31"
                                  option="male"
                                  name="gender"
                                  onChange={this.onChange}
                                  checked={this.state.gender === "male"}
                                  label="Male"
                                />
                                &nbsp;
                                <Radio
                                  // style={{'display':'inline-block'}}
                                  number="32"
                                  option="female"
                                  name="gender"
                                  onChange={this.onChange}
                                  checked={this.state.gender === "female"}
                                  label="Female"
                                />
                                <Radio
                                  // style={{'display':'inline-block'}}
                                  number="11"
                                  option="other"
                                  name="gender"
                                  onChange={this.onChange}
                                  checked={this.state.gender === "other"}
                                  label="Other"
                                />
                              </div>
                            </FormGroup>
                          </>
                        )}
                        <FormGroup>
                          {Number(this.state.role) !== 8 && (
                            <>
                              <ControlLabel>Address Line 1</ControlLabel>
                              <FormControl
                                name="addressline1"
                                value={this.state.addressline1}
                                onChange={(event) => {
                                  this.setState({
                                    addressline1: event.target.value,
                                  });
                                }}
                                placeholder="Enter Address Line1"
                                type="text"
                              />
                              <ControlLabel>Address Line 2</ControlLabel>
                              <FormControl
                                name="addressline2"
                                value={this.state.addressline2}
                                onChange={this.onChange}
                                placeholder="Enter Address Line2"
                                type="text"
                              />
                              <ControlLabel>Postal code</ControlLabel>
                              <FormControl
                                name="postalcode"
                                value={this.state.postalcode}
                                onWheel={(e) => e.target.blur()}
                                onChange={(event) => {
                                  this.setState({
                                    postalcode: event.target.value,
                                  });
                                }}
                                placeholder="Enter Postal Code"
                                type="number"
                              />
                            </>
                          )}

                          <ControlLabel>Country</ControlLabel>
                          <select
                            name="country"
                            value={this.state.country}
                            onChange={this.handleInputChange}
                            className="form-control"
                          >
                            <option value="0">Select Country</option>
                            {this.state.country_detail.map((country_data) => (
                              <option value={country_data.id}>
                                {country_data.country_name}
                              </option>
                            ))}
                          </select>

                          <br></br>

                          <ControlLabel>&nbsp;State</ControlLabel>
                          <FormControl
                            name="state"
                            value={this.state.state}
                            onChange={(event) => {
                              this.setState({ state: event.target.value });
                            }}
                            placeholder="Enter State"
                            type="text"
                          />

                          <ControlLabel>District</ControlLabel>
                          <select
                            name="city"
                            value={this.state.city}
                            onChange={this.onChange}
                            className="form-control"
                          >
                            <option value="0">Select District</option>
                            {this.state.city_info.map((city) => (
                              <option value={city.id}>{city.city_name}</option>
                            ))}
                          </select>
                        </FormGroup>

                        {(this.state.role == "17" ||
                          this.state.role == "18" ||
                          this.state.role == "5" ||
                          this.state.role == "7" ||
                          this.state.role == "13" ||
                          this.state.role == "6" ||
                          this.state.role == "11" ||
                          this.state.role == "2" ||
                          this.state.role == "3") && (
                          <FormGroup>
                            <ControlLabel>Branch</ControlLabel>
                            {/* <select
                              name="district"
                              value={this.state.district}
                              onChange={this.onChange}
                              className="form-control"
                            >
                              <option value="0">Select Branch</option>
                              {this.state.branchList.map((data) => (
                                <option value={data.name}>{data.name}</option>
                              ))}
                            </select> */}
                            <Select
                              placeholder="Store Branch"
                              name="store_Branch"
                              value={this.state.store}
                              onChange={(value) =>
                                this.setState({
                                  store: value,
                                  storeError: value
                                    ? null
                                    : "Please select a store branch",
                                })
                              }
                              options={this.state.branchList}
                            />
                            {this.state.storeError}
                          </FormGroup>
                        )}

                        {this.state.showOption == true && (
                          <FormGroup>
                            <ControlLabel className="roleLabel">
                              Doctor Speciality{" "}
                            </ControlLabel>
                            <Select
                              placeholder="Doctor Speciality"
                              name="doctor_speciality"
                              closeMenuOnSelect={true}
                              value={this.state.doctor_speciality}
                              onChange={(value) =>
                                this.onSpecialityChange(value)
                              }
                              options={this.state.doctorspecialityItems}
                            />

                            {this.state.doctor_specialityError}
                          </FormGroup>
                        )}
                        {this.state.showOption == true && (
                          <FormGroup>
                            <ControlLabel className="roleLabel">
                              Language{" "}
                            </ControlLabel>
                            <Select
                              className="react-select info"
                              classNamePrefix="react-select"
                              placeholder="Select Language"
                              name="doctor_language"
                              closeMenuOnSelect={false}
                              isMulti
                              value={this.state.doctor_language}
                              onChange={(value) => {
                                this.setState({ doctor_language: value });
                              }}
                              options={[
                                { value: "English", label: "English" },
                                { value: "Sinhala", label: "Sinhala" },
                                { value: "Tamil", label: "Tamil" },
                                { value: "Hindi", label: "Hindi" },
                                { value: "Mandarin", label: "Mandarin" },
                                { value: "Russian", label: "Russian" },
                                { value: "Arabic", label: "Arabic" },
                                { value: "Bengali", label: "Bengali" },
                                { value: "Dhivehi", label: "Dhivehi" },
                                { value: "Swedish", label: "Swedish" },
                              ]}
                            />

                            {this.state.doctor_languageError}
                          </FormGroup>
                        )}
                        {this.state.showOption == true && (
                          <FormGroup>
                            <ControlLabel>Qualification</ControlLabel>
                            <FormControl
                              type="text"
                              onChange={(event) =>
                                this.handlequalificationchnage(event)
                              }
                              required
                              name="name"
                              value={this.state.qualification || ""}
                              placeholder="Your Qualification"
                            />
                            {this.state.qualificationError}
                          </FormGroup>
                        )}
                        {this.state.showOption == true && (
                          <FormGroup>
                            <ControlLabel>Registration Id</ControlLabel>
                            <FormControl
                              type="text"
                              onChange={(event) =>
                                this.handleregistration_idchnage(event)
                              }
                              required
                              name="name"
                              value={this.state.registration_id || ""}
                              placeholder="Your Registration Id"
                            />
                            {this.state.registration_idError}
                          </FormGroup>
                        )}

                        {this.state.role == 9 && (
                          <FormGroup>
                            <ControlLabel>Doctor Description</ControlLabel>
                            <textarea
                              className="text-area-modification"
                              rows={5}
                              style={{ width: "100%", resize: "none" }}
                              onChange={(event) => this.docDescChange(event)}
                              name="doc_desc"
                              value={this.state.doc_desc || ""}
                              placeholder="Doctor Description"
                            />
                            {this.state.doc_desc_err}
                          </FormGroup>
                        )}

                        {this.state.role == 9 && (
                          <FormGroup>
                            <ControlLabel>Doctor Experience(Year)</ControlLabel>
                            <FormControl
                              type="text"
                              onChange={(event) => this.docExpChange(event)}
                              required
                              name="doc_exp"
                              value={this.state.doc_exp || ""}
                              placeholder="Doctor Experience"
                            />
                            {this.state.doc_exp_err}
                          </FormGroup>
                        )}

                        {this.state.showOption == true && (
                          <FormGroup>
                            <ControlLabel>Quality</ControlLabel>
                            <select
                              name="quality"
                              value={this.state.quality}
                              onChange={this.onChange}
                              className="form-control"
                            >
                              <option value="">Select Quality</option>
                              <option value="Friendly">Friendly</option>
                              <option value="Kind">Kind</option>
                              <option value="Patience">Patience</option>
                            </select>
                          </FormGroup>
                        )}

                        {this.state.role == 9 && (
                          <FormGroup>
                            <ControlLabel>Is Consultation Type?</ControlLabel>
                            <div className="order_source_data">
                              <Radio
                                number="187"
                                option="TALK_NOW"
                                name="doctor_preference"
                                onChange={this.onChange}
                                checked={
                                  this.state.doctor_preference === "TALK_NOW"
                                }
                                label="Talk Now"
                              />
                              &nbsp;
                              <Radio
                                number="188"
                                option="TALK_LATER"
                                name="doctor_preference"
                                onChange={this.onChange}
                                checked={
                                  this.state.doctor_preference === "TALK_LATER"
                                }
                                label="Talk Later"
                              />
                              &nbsp;
                              <Radio
                                number="189"
                                option="BOTH"
                                name="doctor_preference"
                                onChange={this.onChange}
                                checked={
                                  this.state.doctor_preference === "BOTH"
                                }
                                label="Both"
                              />
                              &nbsp;
                              <Radio
                                number="190"
                                option="GLOBAL"
                                name="doctor_preference"
                                onChange={this.onChange}
                                checked={
                                  this.state.doctor_preference === "GLOBAL"
                                }
                                label="Global"
                              />
                            </div>
                          </FormGroup>
                        )}

                        {this.state.showOption == true && (
                          <FormGroup>
                            <ControlLabel>Is show in app?</ControlLabel>

                            <div className="order_source_data">
                              <Radio
                                disabled={
                                  this.state.is_show_allow ? false : true
                                }
                                number="87"
                                option="Yes"
                                name="is_show_in_app"
                                onChange={this.onChange}
                                checked={this.state.is_show_in_app === "Yes"}
                                label="Yes"
                              />
                              &nbsp;
                              <Radio
                                disabled={
                                  this.state.is_show_allow ? false : true
                                }
                                number="88"
                                option="No"
                                name="is_show_in_app"
                                onChange={this.onChange}
                                checked={this.state.is_show_in_app === "No"}
                                label="No"
                              />
                            </div>
                          </FormGroup>
                        )}

                        {this.state.showOption == true && (
                          <FormGroup>
                            <ControlLabel>Signature</ControlLabel>
                            <br></br>
                            {this.state.oldSignatutefile != null ? (
                              <>
                                <a
                                  target="_blank"
                                  href={this.state.oldSignatutefile}
                                >
                                  <img
                                    style={{
                                      height: "35px",
                                      width: "35px",
                                      border: "1px solid black",
                                      borderRadius: "50%",
                                      marginBottom: "3px",
                                    }}
                                    src={this.state.oldSignatutefile}
                                  ></img>
                                </a>
                                <br></br>
                              </>
                            ) : (
                              ""
                            )}
                            <input
                              style={{ display: "none" }}
                              id="selectSignature"
                              type="file"
                              className="form-control"
                              name="signature"
                              onChange={this.handleSignatureFileChange}
                            />
                            <Button
                              onClick={this.uploadSignature}
                              style={{ color: "#2B3A41" }}
                            >
                              {" "}
                              <i
                                className={
                                  this.state.signature == ""
                                    ? "fa fa-plus"
                                    : "fa fa-pencil fa-fw"
                                }
                              ></i>{" "}
                              {this.state.signature == ""
                                ? "Choose Signature"
                                : "Change Signature"}
                            </Button>
                          </FormGroup>
                        )}

                        {this.state.role == 9 && (
                          <>
                            <FormGroup>
                              <ControlLabel className="roleLabel">
                                Charge Type
                              </ControlLabel>
                              <Select
                                placeholder="Charge Type"
                                name="chargeType"
                                closeMenuOnSelect={true}
                                value={this.state.chargeType}
                                onChange={(value) =>
                                  this.onChargeTypeChange(value)
                                }
                                options={this.state.chargeTypeOptions}
                              />
                            </FormGroup>
                            <FormGroup>
                              <ControlLabel>Consultation Fee</ControlLabel>
                              <FormControl
                                type="text"
                                onChange={(event) =>
                                  this.onCunsultFeeChange(event)
                                }
                                required
                                name="consultation_fee"
                                value={this.state.consultation_fee || ""}
                                placeholder="Enter Consultation Fee"
                              />
                              {this.state.consultfee_err}
                            </FormGroup>
                            <Row>
                              <Col md={4} sm={4} xs={12}>
                                <FormGroup>
                                  <ControlLabel>Consultation Rate</ControlLabel>
                                  <FormControl
                                    type="text"
                                    onChange={(event) =>
                                      this.onCunsultRateChange(event)
                                    }
                                    required
                                    name="consultation_rate"
                                    value={this.state.consultation_rate || ""}
                                    placeholder="Enter Consultation Rate"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4} sm={4} xs={12}>
                                <FormGroup>
                                  <ControlLabel>Lab Rate</ControlLabel>
                                  <FormControl
                                    type="text"
                                    onChange={(event) =>
                                      this.onLabRateChange(event)
                                    }
                                    required
                                    name="lab_rate"
                                    value={this.state.lab_rate || ""}
                                    placeholder="Enter Lab Rate"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4} sm={4} xs={12}>
                                <FormGroup>
                                  <ControlLabel>Medication Rate</ControlLabel>
                                  <FormControl
                                    type="text"
                                    onChange={(event) =>
                                      this.onMedicationRateChange(event)
                                    }
                                    required
                                    name="medication_rate"
                                    value={this.state.medication_rate || ""}
                                    placeholder="Enter Medication Rate"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          </>
                        )}

                        <FormGroup>
                          <ControlLabel>Profile Photo</ControlLabel>
                          <br></br>
                          {this.state.oldprofile != null ? (
                            <>
                              <a target="_blank" href={this.state.oldprofile}>
                                <img
                                  style={{
                                    height: "35px",
                                    width: "35px",
                                    border: "1px solid black",
                                    borderRadius: "50%",
                                    marginBottom: "3px",
                                  }}
                                  src={this.state.oldprofile}
                                ></img>
                              </a>
                              <br></br>
                            </>
                          ) : (
                            ""
                          )}
                          <input
                            style={{ display: "none" }}
                            id="selectImage"
                            type="file"
                            className="form-control"
                            name="profile"
                            onChange={this.handleFileChange}
                          />
                          <Button
                            onClick={this.upload}
                            style={{ color: "#2B3A41" }}
                          >
                            {" "}
                            <i
                              className={
                                this.state.profile == ""
                                  ? "fa fa-plus"
                                  : "fa fa-pencil fa-fw"
                              }
                            ></i>{" "}
                            {this.state.profile == ""
                              ? "Choose image"
                              : "Change image"}
                          </Button>
                        </FormGroup>

                        <FormGroup style={{ display: "none" }}>
                          <ControlLabel>Documents</ControlLabel>
                          <br></br>
                          {this.state.proofurl.map((pre) => (
                            <>
                              {pre.proof_url != "" && (
                                <a
                                  style={{
                                    "font-size": "25px",
                                    display: "inline-block",
                                    color: "black",
                                  }}
                                  href={pre.proof_url}
                                  target="_blank"
                                >
                                  <Button style={{ marginRight: "3px" }}>
                                    P{p++}
                                  </Button>
                                </a>
                              )}
                            </>
                          ))}
                          <input
                            style={{ display: "none" }}
                            id="selectImage2"
                            type="file"
                            className="form-control"
                            name="prescription"
                            multiple
                            onChange={this.handleFileChangeMultiple}
                            placeholder="Enter oPharma Referance"
                          />
                          <Button
                            onClick={this.upload2}
                            style={{ color: "#2B3A41" }}
                          >
                            {" "}
                            <i
                              className={
                                this.state.selectedFile == ""
                                  ? "fa fa-plus"
                                  : "fa fa-pencil fa-fw"
                              }
                            ></i>{" "}
                            {this.state.selectedFile == ""
                              ? "Choose File"
                              : "Change File"}
                          </Button>
                        </FormGroup>
                        {errormessages.length != 0 && (
                          <div style={{ color: "red", marginBottom: "10px" }}>
                            {errormessages.map((data) => (
                              <React.Fragment>{data}</React.Fragment>
                            ))}
                          </div>
                        )}

                        <Button
                          className="btn-color"
                          onClick={this.onSubmit.bind(this)}
                          fill
                        >
                          Update
                        </Button>
                      </Col>
                    </Row>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default EditUserPo;
